'use strict';
(function($){
	/*
	 * Vetology.ProgressAnimation widget
	 *
	 * @description	This is the main Vetology ProgressAnimation widget
	 *
	 * @options		See description for each option
	 *
	 * @method		See description above each method
	 */
	$.widget(
		'Vetology.ProgressAnimation',
		{
			"options": {
			},
			/*
			 * Vetology.ProgressAnimation._init
			 *
			 * @description	Initializes the Vetology.ProgressAnimation
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._initProgress();
			},
			/*
			 * Vetology.ProgressAnimation._initProgress
			 *
			 * @description	
			 *
			 * @return NULL
			 *
			 */
			"_initProgress": function(){
				var o = this;
				var values = o.element.data("values");
				var html = o._getHtml(o.element);
				o.element.html(html);
				$.each(values, function(i, val){
					var value = 0;
					var trimmed_value = parseInt(val.value);
					var loops = 0;
					var progressBar = document.querySelector("#" + val.id);
					var pbi = setInterval(
						function(){
							if(value != trimmed_value && loops < 100){
								value += 1;
								loops ++;
								o.setBarValue(progressBar, value);
							} else {
								clearInterval(pbi);
								o.setBarValue(progressBar, val.value);
							}
						}, 30
					);
				});
			},
			/*
			 * Vetology.ProgressAnimation._setBarValue
			 *
			 * @description	
			 *
			 * @return NULL
			 *
			 */
			"setBarValue": function(progressBar, value){
				var radius = $(progressBar).attr("r");
				var circumference = 2 * Math.PI * radius;
				var progress = value / 100;
				var dashoffset = circumference * (1 - progress);
				progressBar.style.strokeDashoffset = dashoffset;
				progressBar.style.strokeDasharray = circumference;
				progressBar.style.stroke = $(progressBar).data("color");
			},
			/*
			 * Vetology.ProgressAnimation._eventHandlers
			 *
			 * @description	
			 *
			 * @return NULL
			 *
			 */
			"_getHtml": function(element){
				var html = '<div class="radial-progress">';
				if(typeof element.data("image") !== "undefined"){
					html += '<img src="' + element.data("image") + '" class="radial-image"/>';
				}
				html += '<svg class="radial-progress-wrapper" width="120" height="120" viewBox="0 0 120 120">' +
				'<circle class="radial-bars main-radial-bar" cx="60" cy="60" r="54" stroke-width="6" />';
				$.each(element.data("values"), function(i, val){
					html += '<circle data-color="' + val.color + '" id="' + val.id + '" title="' + val.title + '" class="radial-index-' + i + ' radial-bars radial-bar" cx="60" cy="60" r="54" style="stroke: ' + val.color + ';" />';
				});
				html += '</svg>' +
				'</div>';
				return html;
			}
		}
	);
})(jQuery);